import { render, staticRenderFns } from "./EditMatching.vue?vue&type=template&id=34573934&scoped=true"
import script from "./EditMatching.vue?vue&type=script&lang=js"
export * from "./EditMatching.vue?vue&type=script&lang=js"
import style0 from "./EditMatching.vue?vue&type=style&index=0&id=34573934&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34573934",
  null
  
)

export default component.exports